import * as React from "react";

import SnapminLink from "./SnapminLink";
import BackOfficeLink from "./BackOfficeLink";

type Props = {
  backofficeUrl: string;
  snapminUrl: string;
  children?: any;
};

const backOfficeAndSnapminLink = (props: Props) => (
  <SnapminLink snapminUrl={props.snapminUrl}>
    <BackOfficeLink backofficeUrl={props.backofficeUrl}>
      {props.children}
    </BackOfficeLink>
  </SnapminLink>
);

export default backOfficeAndSnapminLink;
